import BusinessOrdersTableComponent from "../../../components/orders/BusinessOrdersTableComponent";

export const OrdersHistoryPageComponent = () => {
  return (
    <div className="ordersHistoryPageContainer">
      <h1>היסטוריית הזמנות</h1>
      <BusinessOrdersTableComponent />
    </div>
  );
};

export default OrdersHistoryPageComponent;
